import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';

// components
import { Button, Card, CardBody, CardHeader, FormGroup, Form, Input, Row, Col, Spinner } from "reactstrap";
import Select from 'react-select'
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';

// helpers
import { showMessage } from "../../../helpers/message.js";

// api
import penalidade_api from "../../../api/penalidade_api.js";
import concessionaria_api from "../../../api/concessionaria_api.js";
import usuario_api from "../../../api/usuario_api.js";

export default function PenalidadeFicha({ item, handleReturn }) {

    const { register, errors, handleSubmit, setValue, clearErrors } = useForm({ mode: "onBlur" });

    const [showLoading, setshowLoading] = useState(false);
    const [isDisable, set_isDisable] = useState(true);

    // Status
    const options_status = [
        { label: "Ativo", value: "Ativo" },
        { label: "Inativo", value: "Inativo" }
    ];
    const [status, set_status] = useState(null);
    const handleChangeStatus = (value) => {
        set_status(value);
        clearErrors("status");
        setValue("status", value, true);
    }

    // Penalidade x Concessionária
    const [options_penalidadeConcessionarias, set_options_penalidadeConcessionarias] = useState([]);
    const loadPenalidadeConcessionarias = () => {
        concessionaria_api.getAll().then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                let _options = [];
                result.data.map(m => {
                    let _penalidadeConcessionaria = null;
                    if (item != null && item.penalidadeConcessionaria.filter(f => f.concessionaria_Id == m.concessionaria_Id).length > 0)
                        _penalidadeConcessionaria = item.penalidadeConcessionaria.filter(f => f.concessionaria_Id == m.concessionaria_Id)[0];

                    _options.push({
                        penalidadeConcessionaria_Id: _penalidadeConcessionaria != null ? _penalidadeConcessionaria.penalidadeConcessionaria_Id : 0,
                        penalidade_Id: item != null ? item.penalidade_Id : 0,
                        concessionaria_Identificacao: m.identificacao,
                        concessionaria_Id: m.concessionaria_Id,
                        advertencia: _penalidadeConcessionaria != null ? _penalidadeConcessionaria.advertencia : '',
                        valor: _penalidadeConcessionaria != null && _penalidadeConcessionaria.valor != null ? _penalidadeConcessionaria.valor.toFixed(2) : 0,
                        valorReincidencia: _penalidadeConcessionaria != null && _penalidadeConcessionaria.valorReincidencia != null ? _penalidadeConcessionaria.valorReincidencia.toFixed(2) : 0,
                        valorSegundaReincidencia: _penalidadeConcessionaria != null && _penalidadeConcessionaria.valorSegundaReincidencia != null ? _penalidadeConcessionaria.valorSegundaReincidencia.toFixed(2) : 0,
                    });
                })       
                set_options_penalidadeConcessionarias(_options);
            }
        })
    }
    const handleChangeValor = (concessionaria_Id, valor) => {
        let _options = [];
        options_penalidadeConcessionarias.map(m => {
            if (m.concessionaria_Id == concessionaria_Id)
                m.valor = valor == '' ? 0 : valor;
            _options.push(m);
        });                
        set_options_penalidadeConcessionarias(_options);        
    }
    const handleChangeValorReincidencia = (concessionaria_Id, valor) => {
        let _options = [];
        options_penalidadeConcessionarias.map(m => {
            if (m.concessionaria_Id == concessionaria_Id)
                m.valorReincidencia = valor == '' ? 0 : valor;
            _options.push(m);
        });                
        set_options_penalidadeConcessionarias(_options);        
    }
    const handleChangeValorSegundaReincidencia = (concessionaria_Id, valor) => {
        let _options = [];
        options_penalidadeConcessionarias.map(m => {
            if (m.concessionaria_Id == concessionaria_Id)
                m.valorSegundaReincidencia = valor == '' ? 0 : valor;
            _options.push(m);
        });                
        set_options_penalidadeConcessionarias(_options);        
    }
    const handleChangeAdvertencia = (concessionaria_Id, valor) => {
        let _options = [];
        options_penalidadeConcessionarias.map(m => {
            if (m.concessionaria_Id == concessionaria_Id)
                m.advertencia = valor;
            _options.push(m);
        });                
        set_options_penalidadeConcessionarias(_options);        
    }


    const Voltar = () => {
        handleReturn();
    }

    useEffect(() => {
        usuario_api.getFuncionalidadeAcaoLiberada("CadastroPenalidade", "Editar").then((result) => { set_isDisable(!result); })

        loadForm();
        loadPenalidadeConcessionarias();
    }, []);

    const loadForm = () => {
        if (item != null) {
            setValue("descricao", item.descricao);
            setValue("clausulaContratual", item.clausulaContratual);
            set_status(item.status);
            setValue("status", item.status, true);
        }
    }

    const onSubmit = (data) => {
        let json_submit = {
            penalidade_Id: item != null ? item.penalidade_Id : 0,
            descricao: data.descricao,
            clausulaContratual: data.clausulaContratual,
            status: status,
            penalidadeConcessionaria: options_penalidadeConcessionarias
        };

        setshowLoading(true);
        if (json_submit.penalidade_Id == 0)
            penalidade_api.post(json_submit).then(result => handleReturnSubmit(result));
        else
            penalidade_api.put(json_submit).then(result => handleReturnSubmit(result));
    }

    const handleReturnSubmit = (result) => {
        setshowLoading(false);
        if (result.status !== 200) {
            showMessage("Aviso", result.message, 'error', null);
        }
        else {
            showMessage("Aviso", "Operação executada com sucesso!", 'success', handleReturn);
        }
    }

    return (
        <>
            {showLoading &&
                <div className="carregandoCmp">
                    <div className="box">
                        <Spinner></Spinner>
                    </div>
                </div>
            }
            <div className="content">
                <Row>
                    <Col md="12">
                        <Button color="default" onClick={Voltar}>
                            <i className="fas fa-chevron-left"></i>  Voltar
                            </Button>
                    </Col>
                </Row>
                <Card>
                    <CardHeader>
                        <h4 className="titleCard">Penalidade</h4>
                    </CardHeader>
                    <CardBody>
                        <Form onSubmit={handleSubmit(onSubmit)}>
                            <Row className="align-items-end">
                                <Col lg="12" md="12" sm="12">
                                    <FormGroup>
                                        <label className="form-control-label">Descrição</label>
                                        <Input className="form-control"
                                            autocomplete="off"
                                            type="text"
                                            name="descricao"
                                            innerRef={register({ required: true })}
                                            disabled={isDisable}
                                        />
                                        {errors.descricao && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                    </FormGroup>
                                </Col>
                                <Col lg="9" md="8" sm="12">
                                    <FormGroup>
                                        <label className="form-control-label">Cláusula Contratual</label>
                                        <Input className="form-control"
                                            autocomplete="off"
                                            type="text"
                                            name="clausulaContratual"
                                            innerRef={register({ required: true })}
                                            disabled={isDisable}
                                        />
                                        {errors.clausulaContratual && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                    </FormGroup>
                                </Col>
                                <Col lg="3" md="4" sm="12">
                                    <FormGroup>
                                        <label className="form-control-label">Status</label>
                                        <Select
                                            name="status"
                                            options={options_status}
                                            getOptionLabel={o => o.label}
                                            getOptionValue={o => o.value}
                                            value={options_status.filter(f => f.value == status)}
                                            onChange={(e) => handleChangeStatus(e.value)}
                                            classNamePrefix="select"
                                            placeholder="[ Selecione ]"
                                            ref={e => register(
                                                { name: "status" },
                                                { required: true })
                                            }
                                            isDisabled={isDisable}
                                        />
                                        {errors.status && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                    </FormGroup>
                                </Col>
                            </Row>
                            <h5 className="subtitleCard">Valor da Penalidade por Concessionária</h5>
                            <Row>
                                <Col lg="12" md="12" sm="12">
                                    <TableContainer component={Paper}>
                                        <Table size="small">
                                            <TableHead>
                                                <TableRow>
                                                    <StyledTableCell align="left">Concessionária</StyledTableCell>
                                                    <StyledTableCell align="left">Advertência</StyledTableCell>
                                                    <StyledTableCell align="right">Valor</StyledTableCell>
                                                    <StyledTableCell align="right">Valor Primeira Reincidência</StyledTableCell>
                                                    <StyledTableCell align="right">Valor Segunda Reincidência</StyledTableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {options_penalidadeConcessionarias.map((n, key2) => (
                                                    <StyledTableRow key={key2}>
                                                        <StyledTableCell align="left">{n.concessionaria_Identificacao}</StyledTableCell>
                                                        <StyledTableCell align="right">
                                                            <Input 
                                                                className="form-control text-right"
                                                                autocomplete="off"
                                                                type="text"
                                                                name="advertencia"
                                                                defaultValue={n.advertencia}
                                                                onBlur={(e) => handleChangeAdvertencia(n.concessionaria_Id, e.target.value)}
                                                                innerRef={register({ required: false })}
                                                                disabled={isDisable}
                                                            />
                                                        </StyledTableCell>
                                                        <StyledTableCell align="right">
                                                            <Input 
                                                                className="form-control text-right"
                                                                autocomplete="off"
                                                                type="number"
                                                                name="valor"
                                                                step={0.01}
                                                                defaultValue={n.valor}
                                                                onBlur={(e) => handleChangeValor(n.concessionaria_Id, e.target.value)}
                                                                innerRef={register({ required: false })}
                                                                disabled={isDisable}
                                                            />
                                                        </StyledTableCell>
                                                        <StyledTableCell align="right">
                                                            <Input 
                                                                className="form-control text-right"
                                                                autocomplete="off"
                                                                type="number"
                                                                name="valorReincidencia"
                                                                step={0.01}
                                                                defaultValue={n.valorReincidencia}
                                                                onBlur={(e) => handleChangeValorReincidencia(n.concessionaria_Id, e.target.value)}
                                                                innerRef={register({ required: false })}
                                                                disabled={isDisable}
                                                            />
                                                        </StyledTableCell>
                                                        <StyledTableCell align="right">
                                                            <Input className="form-control text-right"
                                                                autocomplete="off"
                                                                type="number"
                                                                name="valorSegundaReincidencia"
                                                                step={0.01}
                                                                defaultValue={n.valorSegundaReincidencia}
                                                                onBlur={(e) => handleChangeValorSegundaReincidencia(n.concessionaria_Id, e.target.value)}
                                                                innerRef={register({ required: false })}
                                                                disabled={isDisable}
                                                            />
                                                        </StyledTableCell>
                                                    </StyledTableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Col>
                            </Row>
                            {!isDisable &&
                                <Row>
                                    <Col lg="12" md="12" sm="12" className="text-center">
                                        <Button color="success" type="submit">
                                            <i className="fas fa-save"></i>  Salvar
                                        </Button>
                                    </Col>
                                </Row>
                            }
                        </Form>
                    </CardBody>
                </Card>
            </div>
        </>
    );
}

const StyledTableCell = withStyles((theme) => ({
    head: {
        fontWeight: "bold",
        fontFamily: "Montserrat",
        paddingTop: "10px",
        paddingBottom: "10px"
    },
    body: {
        fontFamily: "Montserrat",
        paddingTop: "10px",
        paddingBottom: "10px"
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);